/**************************************************
 * Nombre:       TextoMovimiento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Marquee from "react-fast-marquee";

const TextoMovimiento = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Marquee autoFill={true} gradient speed={20} style={{overflowY: 'hidden'}}>
                <Typography sx={{
                    pl: 6,
                    fontSize: 180,
                    fontWeight: 800,
                    color: '#ffffff00',
                    WebkitTextStroke: '1px #00000040',
                    lineHeight: 1
                }}>{item.textoMovimiento}</Typography>
            </Marquee>

            <Marquee autoFill={true} gradient speed={20} direction={'right'}
                     style={{marginTop: -20, overflowY: 'hidden'}}>
                <Typography sx={{
                    pl: 6,
                    fontSize: 180,
                    fontWeight: 800,
                    color: '#ffffff00',
                    WebkitTextStroke: '1px #00000040',
                    lineHeight: 1
                }}>{item.textoMovimiento}</Typography>
            </Marquee>

            <Marquee autoFill={true} gradient speed={20} style={{marginTop: -20, overflowY: 'hidden'}}>
                <Typography sx={{
                    pl: 6,
                    fontSize: 180,
                    fontWeight: 800,
                    color: '#ffffff00',
                    WebkitTextStroke: '1px #00000040',
                    lineHeight: 1
                }}>{item.textoMovimiento}</Typography>
            </Marquee>


        </Grid>
    )

}
export default TextoMovimiento